/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/analyticsWidget.config.json";

import { DEFAULT_APP_CONFIG } from "../../../config/default.config";

import { templateReplacer } from "../../../helpers/template.replace";

export interface IAnalyticsWidgetMethods extends IPluginMethodMap {
  getAnalyticsWidgetProps(args: any): Promise<any>;
}

export class AnalyticeWidgetService implements IAgentPlugin {
  readonly methods: IAnalyticsWidgetMethods;

  constructor() {
    this.methods = {
      getAnalyticsWidgetProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return { ...(this.getTransformConfig(config) || {}) };
  }

  private getTransformConfig(data: any) {
    const _transConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
      credential: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credential,
      credentials:
        DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credentials,
    });
    return JSON.parse(_transConfig);
  }
}
